const checkoutBtn = document.querySelector('.cart__checkout');
// Add an event listener for the checkout button click
checkoutBtn.addEventListener('click', async function handleClick(e) {
  // Check if there are products with the 'price-per-kg' property in the cart
  if (document.querySelector('.drawer__inner .cart__items .price-per-kg')) {
    e.preventDefault();
    checkoutBtn.classList.toggle('btn--loading');

    // Collect all products eligible for the 'pricePerKg' property
    const pricePerKgProducts = document.querySelectorAll('[data-price-kg-eligible]');
    const eligibleProductIdsArray = [];
    pricePerKgProducts.forEach(product => {
      eligibleProductIdsArray.push(product.getAttribute('data-price-kg-eligible'));
    });
    try {
      // Fetch the current cart data
      const response = await fetch('/cart.js');
      const data = await response.json();

      // Add the 'pricePerKg' property to eligible products
      await addPropertyPriceKg(data, eligibleProductIdsArray);
      checkoutBtn.classList.toggle('btn--loading');
      checkoutBtn.removeEventListener('click', handleClick);
      checkoutBtn.click();
    } catch (error) {
      console.error('Error updating properties:', error);
      checkoutBtn.classList.toggle('btn--loading');
      checkoutBtn.removeEventListener('click', handleClick);
      checkoutBtn.click();
    }
  }
});

// Event to handle when the page is reloaded
window.addEventListener('load', async () => {
  // Check if properties need to be reset (e.g., user returned from checkout
  if (document.querySelector('[data-property-price-kg-set="true"]')) {
    await removePropertyPriceKg();
    window.location.reload();
  }
});

// Function to add the 'pricePerKg' property to eligible products
async function addPropertyPriceKg(data, eligibleProductIdsArray) {
  const cartData = data;
  try {
    // Clear the current cart
    await fetch('/cart/clear.js', {
      method: 'POST'
    });

    // Prepare updated cart items
    const itemsToAdd = cartData.items.map(item => {
      const product = {
        id: item.id,
        quantity: item.quantity
      };

      // Include existing properties
      if (item.properties) {
        product.properties = {
          ...item.properties
        };
      }

      // Add the 'pricePerKg' property if the product is eligible
      if (eligibleProductIdsArray.includes(item.id.toString())) {
        let pricePerKg = document.querySelector(`[data-key="${item.key}"] [data-price-per-kg]`).getAttribute('data-price-per-kg');
        let pricePerKgName = document.querySelector(`[data-key="${item.key}"] [data-property-translation]`).getAttribute('data-property-translation');
        product.properties = {
          ...product.properties,
          [pricePerKgName]: pricePerKg
        };
      }
      return product;
    });

    // Avoid bug in the checkout that invert quantity between line-items
    const reversedItemsToAdd = itemsToAdd.reverse();

    // Add updated items to the cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: reversedItemsToAdd
      })
    });
  } catch (error) {
    console.error('Error on product update :', error);
  }
}

// Function to remove the 'pricePerKg' property from products
async function removePropertyPriceKg() {
  try {
    // Fetch the current cart data
    const response = await fetch('/cart.js');
    const cartData = await response.json();

    // Prepare updated cart items without the 'pricePerKg' property
    const itemsToUpdate = cartData.items.map(item => {
      if (item.properties && Object.keys(item.properties).length > 0) {
        // Créer une copie des propriétés sans celles qui incluent 'pricePerKg'
        const updatedProperties = {
          ...item.properties
        };
        let pricePerKgName = document.querySelector(`[data-key="${item.key}"] [data-property-translation]`)?.getAttribute('data-property-translation');

        // Remove the 'pricePerKg' property
        for (const key in updatedProperties) {
          if (key.includes(pricePerKgName)) {
            delete updatedProperties[key];
          }
        }

        // Return the updated product data
        return {
          id: item.id,
          quantity: item.quantity,
          properties: Object.keys(updatedProperties).length > 0 ? updatedProperties : null
        };
      }

      // If no properties, return the product unchanged
      return {
        id: item.id,
        quantity: item.quantity
      };
    });

    // Avoid bug in the checkout that invert quantity between line-items
    const itemsToUpdateReverse = itemsToUpdate.reverse();

    // Clear the current cart
    await fetch('/cart/clear.js', {
      method: 'POST'
    });

    // Add updated items to the cart
    const responseAdd = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: itemsToUpdateReverse
      })
    });
    if (!responseAdd.ok) {
      throw new Error('Failed to update cart items');
    }
  } catch (error) {
    console.error('Error removing properties:', error);
  }
}